<template>
  <div class="g-page">
    <div class="content-container">

      <!-- HEADER -->
      <div class="header-row mb-4">
        <div class="d-flex align-items-center">
          <button class="back-circle-btn mr-3" @click="$router.push({ path: '/malumot/user/index' })" type="button">
            <b-icon icon="chevron-left"></b-icon>
          </button>
          <h2 class="page-title">
            {{ $route.params.id ? $t('Foydalanuvchini tahrirlash') : $t('Yangi foydalanuvchi') }}
          </h2>
        </div>
        <div class="header-actions">
          <button class="btn-cancel mr-2" @click="$router.push({ path: '/malumot/user/index' })" type="button">
            {{ $t("Bekor qilish") }} <sup>esc</sup>
          </button>
          <button class="btn-save" @click="Savedokument" type="button">
            <b-icon icon="check-all" class="mr-1"></b-icon>
            {{ $t("Saqlash") }} <sup>ctrl+enter</sup>
          </button>
        </div>
      </div>

      <!-- ASOSIY FORMA -->
      <div class="modern-card">
        <div class="row custom-gutter">

          <!-- Chap tomon: Shaxsiy ma'lumotlar -->
          <div class="col-md-5 section-divider">
            <div class="section-header">
              <b-icon icon="person-lines-fill"></b-icon>
              <span>{{ $t("Shaxsiy ma'lumotlar") }}</span>
            </div>

            <div class="form-unit">
              <label>{{ $t("Ismi") }} <span class="required-star">*</span></label>
              <input
                v-model="datas.first_name"
                type="text"
                :placeholder="$t('Kiriting...')"
                ref="focused"
                :class="{ 'input-error': errors.first_name }"
              >
              <small v-if="errors.first_name" class="error-text">{{ errors.first_name }}</small>
            </div>

            <div class="form-unit">
              <label>{{ $t("Familiya") }} <span class="required-star">*</span></label>
              <input
                v-model="datas.last_name"
                type="text"
                :placeholder="$t('Kiriting...')"
                :class="{ 'input-error': errors.last_name }"
              >
              <small v-if="errors.last_name" class="error-text">{{ errors.last_name }}</small>
            </div>

            <div class="form-unit">
              <label>{{ $t("Pochta") }} <span class="optional-text">({{ $t("majburiy emas") }})</span></label>
              <input
                v-model="datas.email"
                type="email"
                placeholder="example@mail.com"
                :class="{ 'input-error': errors.email }"
              >
              <small v-if="errors.email" class="error-text">{{ errors.email }}</small>
            </div>

            <div class="row">
              <div class="col-6">
                <div class="form-unit">
                  <label>{{ $t("Sklad") }} <span class="required-star">*</span></label>
                  <v-select
                    :disabled="skladhave"
                    :clearable="false"
                    class="modern-vselect"
                    :class="{ 'select-error': errors.sklad_id }"
                    :options="skladlist"
                    v-model="datas.sklad_id"
                    :reduce="name => name.id"
                    label="name"
                    :placeholder="$t('Tanlang')"
                  >
                    <template #search="{attributes, events}">
                      <input class="vs__search" v-bind="attributes" v-on="events" />
                    </template>
                    <template #selected-option="{ name }">{{ name }}</template>
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching">
                        <em><b>{{ search }}</b></em> {{ $t("бўйича маьлумот йўқ") }}
                      </template>
                      <em style="opacity: 0.5;" v-else>{{ $t("Маьлумот йўқ") }}</em>
                    </template>
                  </v-select>
                  <small v-if="errors.sklad_id" class="error-text">{{ errors.sklad_id }}</small>
                </div>
              </div>
              <div class="col-6">
                <div class="form-unit">
                  <label>{{ $t("Xodim") }} <span class="optional-text">({{ $t("majburiy emas") }})</span></label>
                  <v-select
                    :clearable="true"
                    class="modern-vselect"
                    :options="stafflist"
                    v-model="datas.staff_id"
                    :reduce="name => name.id"
                    label="name"
                    :placeholder="$t('Tanlang')"
                  >
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching">
                        <em><b>{{ search }}</b></em> {{ $t("бўйича маьлумот йўқ") }}
                      </template>
                      <em style="opacity: 0.5;" v-else>{{ $t("Маьлумот йўқ") }}</em>
                    </template>
                  </v-select>
                </div>
              </div>
            </div>

            <div class="form-unit">
              <label>{{ $t("Roli") }} <span class="required-star">*</span></label>
              <v-select
                :clearable="false"
                class="modern-vselect"
                :options="roleOptions"
                v-model="datas.role"
                :reduce="r => r.value"
                label="name"
              >
                <template #search="{attributes, events}">
                  <input class="vs__search" v-bind="attributes" v-on="events" />
                </template>
              </v-select>
              <small class="optional-text">{{ $t("Admin — foydalanuvchilarni boshqara oladi; SuperUser — to'g'ridan-to'g'ri savdo (POS) sahifasiga kiradi") }}</small>
            </div>

            <div class="section-header mt-3">
              <b-icon icon="shield-lock"></b-icon>
              <span>{{ $t("Kirish ma'lumotlari") }}</span>
            </div>

            <div class="form-unit">
              <label>{{ $t("Login") }} <span class="required-star">*</span></label>
              <input
                v-model="datas.username"
                type="text"
                placeholder="login"
                :class="{ 'input-error': errors.username }"
              >
              <small v-if="errors.username" class="error-text">{{ errors.username }}</small>
            </div>

            <div class="row">
              <div class="col-6">
                <div class="form-unit">
                  <label>
                    {{ $t("Parol") }}
                    <span v-if="isCreate" class="required-star">*</span>
                    <span v-else class="optional-text">({{ $t("majburiy emas") }})</span>
                  </label>
                  <div class="password-wrapper">
                    <input
                      v-model="datas.password"
                      :type="showPassword ? 'text' : 'password'"
                      placeholder="••••••"
                      :class="{ 'input-error': errors.password }"
                    >
                    <button
                      type="button"
                      class="password-toggle"
                      @click="showPassword = !showPassword"
                    >
                      <b-icon :icon="showPassword ? 'eye-slash' : 'eye'"></b-icon>
                    </button>
                  </div>
                  <small v-if="errors.password" class="error-text">{{ errors.password }}</small>
                </div>
              </div>
              <div class="col-6">
                <div class="form-unit">
                  <label>
                    {{ $t("Parol tasdiqlash") }}
                    <span v-if="isCreate || datas.password" class="required-star">*</span>
                  </label>
                  <div class="password-wrapper">
                    <input
                      v-model="datas.confirm_password"
                      @change="Changeparol()"
                      :type="showConfirmPassword ? 'text' : 'password'"
                      placeholder="••••••"
                      :class="{ 'input-error': errors.confirm_password }"
                    >
                    <button
                      type="button"
                      class="password-toggle"
                      @click="showConfirmPassword = !showConfirmPassword"
                    >
                      <b-icon :icon="showConfirmPassword ? 'eye-slash' : 'eye'"></b-icon>
                    </button>
                  </div>
                  <small v-if="errors.confirm_password" class="error-text">{{ errors.confirm_password }}</small>
                </div>
              </div>
            </div>
          </div>

          <!-- O'ng tomon: Huquqlar jadvali -->
          <div class="col-md-7 pl-md-4">
            <div class="section-header">
              <b-icon icon="key"></b-icon>
              <span>{{ $t("Huquqlar") }}</span>
              <button type="button" class="btn-select-all" @click="Clickall()">
                {{ $t("Barchasini belgilash") }}
              </button>
            </div>

            <div class="rules-table-wrapper">
              <table class="rules-table">
                <thead>
                  <tr>
                    <th>{{ $t("Nomi") }}</th>
                    <th class="th-center">{{ $t("Ko'rish") }}</th>
                    <th class="th-center">{{ $t("Ochish") }}</th>
                    <th class="th-center">{{ $t("O'zgartirish") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, idx) in flatMenuRows" :key="idx"
                      :class="{ 'rule-group-header': row.isGroup }">
                    <template v-if="row.isGroup">
                      <td colspan="4"><strong>{{ row.title }}</strong></td>
                    </template>
                    <template v-else>
                      <td>{{ row.name }}</td>
                      <td class="td-center"><input type="checkbox" v-model="menuRules[row.path].see" class="modern-checkbox"></td>
                      <td class="td-center"><input type="checkbox" v-model="menuRules[row.path].open" class="modern-checkbox"></td>
                      <td class="td-center"><input type="checkbox" v-model="menuRules[row.path].change" class="modern-checkbox"></td>
                    </template>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { print } from "../../../components/mixins/print.js";
import $ from "jquery";

// DashboardLayout.vue dagi menuga mos huquqlar ro'yxati
const MENU_GROUPS = [
  {
    title: 'SAVDO',
    items: [
      { name: "Savdolar ro'yxati", path: '/chiqim/index' },
      { name: 'Savdo (POS)', path: '/chiqim/pos' },
      { name: 'Zakazlar', path: '/zakazlar/index' },
      { name: 'Ombor (Qoldiq)', path: '/ombor' },
      { name: "Ta'minot (Kirim)", path: '/kirim/index' },
    ]
  },
  {
    title: 'MOLIYA',
    items: [
      { name: 'Kassa order (Kirim/Chiqim)', path: '/kassaorder/index' },
      { name: 'Seyf', path: '/safe/index' },
      { name: "Balans o'tkazish", path: '/balans-transfer/index' },
      { name: 'Nasiyalar', path: '/nasiyalar' },
      { name: 'Ustalar', path: '/usta/index' },
    ]
  },
  {
    title: 'BOSHQARUV',
    items: [
      { name: 'Hisobot', path: '/xisobot/main' },
      { name: 'Ustalar hisoboti', path: '/xisobot/masters' },
    ]
  },
  {
    title: "MA'LUMOTLAR",
    items: [
      { name: 'Paketlar', path: '/paket/index' },
      { name: 'Brendlar', path: '/brand/index' },
      { name: 'Kurs', path: '/malumot/dollar/index' },
      { name: 'Modellar', path: '/model/index' },
      { name: 'Mijozlar', path: '/malumot/kontragent/index' },
      { name: "Ta'minotchilar", path: '/taminotchi/index' },
      { name: 'Maxsulotlar', path: '/directory/product/index' },
      { name: 'Takliflar', path: '/offers' },
      { name: 'Kontaktlar', path: '/contact' },
      { name: 'Skladlar', path: '/malumot/sklad/index' },
      { name: 'Foydalanuvchilar', path: '/malumot/user/index' },
      { name: "To'lov turlari", path: '/malumot/paytype/index' },
    ]
  },
];

// Barcha path lardan bo'sh menu_json yaratish
function buildEmptyMenuJson() {
  const obj = {};
  for (const group of MENU_GROUPS) {
    for (const item of group.items) {
      obj[item.path] = { see: false, open: false, change: false };
    }
  }
  return obj;
}

export default {
  name: "user-form",
  mixins: [print],
  data() {
    return {
      filter: "",
      skladlist: [],
      stafflist: [],
      roleOptions: [
        { value: "Admin", name: "Admin" },
        { value: "SuperUser", name: "SuperUser" },
      ],
      menuGroups: MENU_GROUPS,
      menuRules: buildEmptyMenuJson(),
      errors: {},
      showPassword: false,
      showConfirmPassword: false,
    };
  },
  props: ["datas"],
  computed: {
    flatMenuRows() {
      const rows = [];
      for (const group of this.menuGroups) {
        rows.push({ isGroup: true, title: group.title });
        for (const item of group.items) {
          rows.push({ isGroup: false, name: item.name, path: item.path });
        }
      }
      return rows;
    },
    isCreate() {
      return this.$route.path == "/malumot/user/create";
    }
  },
  created() {
    let self = this;
    self.$root.$refs.user = self;
  },
  watch: {
    'datas.menu_json': {
      immediate: true,
      deep: true,
      handler(val) {
        // menu_json dan menuRules ga yuklash
        const base = buildEmptyMenuJson();
        if (val && typeof val === 'object') {
          for (const path in val) {
            if (base[path]) {
              base[path].see = !!val[path].see;
              base[path].open = !!val[path].open;
              base[path].change = !!val[path].change;
            }
          }
        }
        this.menuRules = base;
      }
    }
  },
  mounted: function() {
    this.Skladlist();
    this.Stafflist();
    this.Focus();
  },
  methods: {
    Clickall(){
      for (const path in this.menuRules) {
        this.menuRules[path].see = true;
        this.menuRules[path].open = true;
        this.menuRules[path].change = true;
      }
      // Vue 2 reactivity uchun
      this.menuRules = Object.assign({}, this.menuRules);
    },
    Skladlist() {
      let self = this;
      axios.get("api/v1/sklads").then(function(response) {
        self.skladlist = response.data;
      });
    },
    Stafflist() {
      let self = this;
      axios.get("api/v1/staff").then(function(response) {
        self.stafflist = response.data;
      });
    },
    Changeparol() {
      if (this.datas.password != this.datas.confirm_password) {
        this.$store.state.errors = this.$t("Парол тасдиқланмади");
      }
    },
    Focus() {
      this.$refs.focused.focus();
    },
    Validate() {
      const errors = {};
      const d = this.datas || {};

      // Ismi
      if (!d.first_name || String(d.first_name).trim().length < 3) {
        errors.first_name = this.$t("Ismi kamida 3 ta belgi bo'lishi kerak");
      } else if (String(d.first_name).length > 50) {
        errors.first_name = this.$t("Ismi 50 ta belgidan oshmasligi kerak");
      }

      // Familiya
      if (!d.last_name || String(d.last_name).trim().length < 3) {
        errors.last_name = this.$t("Familiya kamida 3 ta belgi bo'lishi kerak");
      } else if (String(d.last_name).length > 50) {
        errors.last_name = this.$t("Familiya 50 ta belgidan oshmasligi kerak");
      }

      // Email (majburiy emas, lekin yozilsa to'g'ri formatda)
      if (d.email && String(d.email).trim().length > 0) {
        const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRe.test(String(d.email).trim())) {
          errors.email = this.$t("Email manzili noto'g'ri");
        } else if (String(d.email).length > 100) {
          errors.email = this.$t("Email 100 ta belgidan oshmasligi kerak");
        }
      }

      // Sklad
      if (!d.sklad_id) {
        errors.sklad_id = this.$t("Sklad tanlanishi shart");
      }

      // Login
      if (!d.username || String(d.username).trim().length < 3) {
        errors.username = this.$t("Login kamida 3 ta belgi bo'lishi kerak");
      } else if (String(d.username).length > 25) {
        errors.username = this.$t("Login 25 ta belgidan oshmasligi kerak");
      }

      // Parol — create da majburiy, update da o'zgartirilayotgan bo'lsa majburiy
      const passLen = d.password ? String(d.password).length : 0;
      if (this.isCreate) {
        if (passLen < 3) {
          errors.password = this.$t("Parol kamida 3 ta belgi bo'lishi kerak");
        } else if (passLen > 50) {
          errors.password = this.$t("Parol 50 ta belgidan oshmasligi kerak");
        }
      } else if (passLen > 0 && (passLen < 3 || passLen > 50)) {
        errors.password = this.$t("Parol 3 dan 50 ta belgi orasida bo'lishi kerak");
      }

      // Parol tasdiqlash
      if (passLen > 0) {
        if (!d.confirm_password) {
          errors.confirm_password = this.$t("Parolni tasdiqlang");
        } else if (d.password !== d.confirm_password) {
          errors.confirm_password = this.$t("Parollar mos kelmadi");
        }
      }

      this.errors = errors;
      return Object.keys(errors).length === 0;
    },
    Savedokument() {
      let self = this;
      if(self.rule.change==true){
        // Klient validatsiya
        if (!self.Validate()) {
          self.$store.state.errors = self.$t("Iltimos, majburiy maydonlarni to'g'ri to'ldiring");
          return;
        }

        if (this.$route.path == "/malumot/user/create") {
          var methods = "post";
          var action = "api/v1/users";
        } else {
          var methods = "patch";
          var action = "api/v1/users/id/" + self.$route.params.id;
        }

        // menu_json ni datas ga qo'shish
        self.datas.menu_json = self.menuRules;
        // sklad_id butun son bo'lishi kerak
        if (self.datas.sklad_id) {
          self.datas.sklad_id = parseInt(self.datas.sklad_id);
        }
        // bo'sh email backendga null sifatida ketadi
        if (!self.datas.email) {
          self.datas.email = null;
        }
        // confirm_password update da yo'q bo'lsa qo'shib qo'yamiz
        if (!self.isCreate && (self.datas.password === undefined || self.datas.password === null)) {
          self.datas.password = "";
        }
        if (self.datas.confirm_password === undefined || self.datas.confirm_password === null) {
          self.datas.confirm_password = self.datas.password || "";
        }

        axios({
          method: methods,
          url: action,
          data: self.datas
        }).then(function(response) {
          self.$store.state.saved = 1;
          self.$router.push({ name: "Фойдаланувчи" });
        }).catch(function(error) {
          if (error.response && error.response.data) {
            self.$store.state.errors = error.response.data.message || self.$t("Xatolik yuz berdi");
          } else {
            self.$store.state.errors = self.$t("Serverga ulanishda xatolik");
          }
        });
      } else{
        self.$store.state.errors=self.$t('Sizdan bunday xuquq mavjud emas');
      }
    }
  }
};
</script>

<style scoped>
/* SAHIFA ASOSI */
.g-page {
  padding: 30px;
  background: #f4f7f9;
  min-height: 100vh;
}

.content-container {
  max-width: 1300px;
  margin: 0 auto;
}

/* HEADER */
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.page-title {
  font-weight: 800;
  font-size: 24px;
  color: #2c3e50;
  margin: 0;
}

.back-circle-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #e0e6ed;
  background: white;
  color: #7f8c8d;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s;
  cursor: pointer;
}

.back-circle-btn:hover {
  background: #a142f4;
  color: white;
  border-color: #a142f4;
}

/* TUGMALAR */
.btn-save {
  background: #a142f4;
  color: white;
  border: none;
  padding: 10px 25px;
  border-radius: 10px;
  font-weight: 700;
  box-shadow: 0 4px 12px rgba(161, 66, 244, 0.25);
  transition: 0.3s;
  cursor: pointer;
}

.btn-save:hover {
  background: #8e39d9;
  transform: translateY(-1px);
}

.btn-save sup {
  font-weight: 400;
  opacity: 0.7;
}

.btn-cancel {
  background: white;
  border: 1px solid #dcdde1;
  color: #7f8c8d;
  padding: 10px 20px;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
}

.btn-cancel sup {
  font-weight: 400;
  opacity: 0.6;
}

/* MODERN CARD */
.modern-card {
  background: white;
  border-radius: 24px;
  padding: 40px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.02);
  border: 1px solid #f1f2f6;
}

.section-divider {
  border-right: 1px solid #f1f2f6;
  padding-right: 30px;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 25px;
  color: #2c3e50;
  font-weight: 700;
  font-size: 16px;
}

.section-header svg {
  color: #a142f4;
}

/* FORM UNITS */
.form-unit {
  margin-bottom: 20px;
}

.form-unit label {
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: #95a5a6;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.form-unit input[type="text"],
.form-unit input[type="email"],
.form-unit input[type="password"] {
  width: 100%;
  background: #f8fafc;
  border: 1px solid #f8fafc;
  border-radius: 12px;
  padding: 12px 15px;
  color: #2c3e50;
  font-weight: 600;
  transition: 0.3s;
}

.form-unit input[type="text"]:focus,
.form-unit input[type="email"]:focus,
.form-unit input[type="password"]:focus {
  background: white;
  border-color: #a142f4;
  outline: none;
  box-shadow: 0 0 0 4px rgba(161, 66, 244, 0.05);
}

/* MAJBURIY MAYDON BELGILARI */
.required-star {
  color: #e11d48;
  font-weight: 800;
  margin-left: 2px;
}

.optional-text {
  color: #94a3b8;
  font-weight: 500;
  font-size: 11px;
  text-transform: none;
  letter-spacing: 0;
  margin-left: 4px;
}

/* XATOLIK HOLATI */
.form-unit input.input-error {
  background: #fff1f2;
  border-color: #e11d48;
}

.form-unit input.input-error:focus {
  background: white;
  border-color: #e11d48;
  box-shadow: 0 0 0 4px rgba(225, 29, 72, 0.08);
}

::v-deep .modern-vselect.select-error .vs__dropdown-toggle {
  background: #fff1f2;
  border-color: #e11d48;
}

.error-text {
  display: block;
  color: #e11d48;
  font-size: 11px;
  font-weight: 600;
  margin-top: 4px;
  text-transform: none;
  letter-spacing: 0;
}

/* PAROL KO'RSATISH/YASHIRISH */
.password-wrapper {
  position: relative;
}

.password-wrapper input {
  padding-right: 42px !important;
}

.password-toggle {
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  width: 30px;
  height: 30px;
  border: none;
  background: transparent;
  color: #94a3b8;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.2s;
  padding: 0;
}

.password-toggle:hover {
  background: #f0e6ff;
  color: #a142f4;
}

.password-toggle:focus {
  outline: none;
}

/* V-SELECT */
::v-deep .modern-vselect .vs__dropdown-toggle {
  background: #f8fafc;
  border: 1px solid #f8fafc;
  border-radius: 12px;
  padding: 6px;
}

::v-deep .modern-vselect.vs--open .vs__dropdown-toggle {
  background: white;
  border-color: #a142f4;
}

/* BARCHASINI BELGILASH TUGMASI */
.btn-select-all {
  margin-left: auto;
  background: #f0e6ff;
  color: #a142f4;
  border: none;
  padding: 6px 16px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  transition: 0.3s;
}

.btn-select-all:hover {
  background: #a142f4;
  color: white;
}

/* HUQUQLAR JADVALI */
.rules-table-wrapper {
  max-height: 65vh;
  overflow-y: auto;
  border-radius: 12px;
  border: 1px solid #f1f2f6;
}

.rules-table {
  width: 100%;
  border-collapse: collapse;
}

.rules-table thead {
  position: sticky;
  top: 0;
  z-index: 1;
}

.rules-table thead th {
  background: #f8fafc;
  padding: 12px 15px;
  font-size: 12px;
  font-weight: 700;
  color: #95a5a6;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #f1f2f6;
}

.th-center, .td-center {
  text-align: center;
  width: 80px;
}

.rules-table tbody td {
  padding: 10px 15px;
  font-size: 14px;
  color: #2c3e50;
  border-bottom: 1px solid #f8fafc;
}

.rules-table tbody tr:hover:not(.rule-group-header) {
  background: #faf8ff;
}

.rule-group-header td {
  background: #f0f2f5 !important;
  padding: 8px 15px !important;
  font-size: 12px;
  letter-spacing: 0.5px;
  color: #555;
}

.modern-checkbox {
  width: 18px;
  height: 18px;
  accent-color: #a142f4;
  cursor: pointer;
}

.mt-3 { margin-top: 20px; }
.mb-4 { margin-bottom: 24px; }

@media (max-width: 768px) {
  .g-page {
    padding: 15px;
  }

  .modern-card {
    padding: 20px;
  }

  .section-divider {
    border-right: none;
    border-bottom: 1px solid #f1f2f6;
    padding-right: 0;
    margin-bottom: 30px;
    padding-bottom: 30px;
  }

  .header-row {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }
}
</style>
